import React from 'react';

const CustomFooter = () => {
  return (
    <footer style={footerStyle}>
      <div style={footerContentStyle}>
        <span>©亳州术驰科技有限公司</span>
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
        </a>
      </div>
    </footer>
  );
};

// 样式定义
const footerStyle: React.CSSProperties = {
  width: '100%',
  padding: '20px',
  textAlign: 'center',
  position: 'relative',
  bottom: 0,
};

const footerContentStyle: React.CSSProperties = {
  fontSize: '14px',
  color: '#333',
};

const linkStyle: React.CSSProperties = {
  marginLeft: '5px',
  color: '#333',
  textDecoration: 'none',
};

export default CustomFooter;
